import { Certifications } from './certifications';
import { Training } from './training';

export interface TrainingCertifications {
  training: Training;
  certifications: Certifications;
}
